import type { JcCookieConsent } from '../../types/cookie-consent';
import { JC_CONSENT_SCHEMA_VERSION } from './constants';

export function buildConsentState(analytics: boolean, updatedAt: Date = new Date()): JcCookieConsent {
  return {
    v: JC_CONSENT_SCHEMA_VERSION,
    analytics,
    updatedAt: updatedAt.toISOString(),
  };
}
